// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13a6q","buttons":"Footer_buttons__g1jvI"};